import { Serializable } from '@admin/core/models/serializable';
import { SmsStopReasonModel } from './sms-stop-reason-model';

export class SmsTypeModel implements Serializable<SmsTypeModel> {
  public smsTypeId: number;
  public name: string;
  public isSwitchable: boolean;
  public isSwitchableByClient: boolean;

  public stopReasons: SmsStopReasonModel[];

  fromObject(object: any): SmsTypeModel {
    Object.assign(this, object);

    this.stopReasons = [];
    if (
      object.stopReasons &&
      object.stopReasons.length &&
      object.stopReasons.length > 0
    ) {
      object.stopReasons.forEach((r) => {
        let t = new SmsStopReasonModel();
        t = t.fromObject(r);
        this.stopReasons.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }
}
